export default __webpack_public_path__ + "static/media/maintenance-background-image.6d76c088.jpeg";